import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import GlobalStyle from '../../components/Theme/Layout/GlobalStyle';
import Receiver from '../../components/Receiver/Receiver';
import useVoucherHook from '../../components/Receiver/useVoucherHook';
import ReceiverHeader from '../../components/Receiver/ReceiverHeader';
import VoucherError from '../../components/Receiver/VoucherError';

export default function PageIndex(props) {
  const router = useRouter();
  const { isReady, iserror, voucherData } = useVoucherHook({ ...props, query: router.query });
  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <GlobalStyle />
      <ReceiverHeader />

      {iserror ? (
        <VoucherError data-testid="vouchererror" />
      ) : (
        <Receiver
          data-testid="receiver"
          isReady={isReady}
          voucherData={voucherData}
          error={iserror}
        />
      )}
    </>
  );
}
